var _defs, _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "556c312ee9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 137 175 L 673 175 L 673 782.882812 L 137 782.882812 Z M 137 175 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2c90847cdc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 263 26.882812 L 345 26.882812 L 345 129 L 263 129 Z M 263 26.882812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "73d0dc300d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 360 26.882812 L 443 26.882812 L 443 131 L 360 131 Z M 360 26.882812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e146d377d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 458 26.882812 L 540 26.882812 L 540 131 L 458 131 Z M 458 26.882812 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#556c312ee9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#313f52",
    d: "M 404.773438 782.859375 L 185.984375 722.144531 L 137.230469 175.457031 L 672.96875 175.449219 L 624.183594 722.054688 L 404.785156 782.851562 Z M 404.773438 782.859375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71859f",
    d: "M 582.402344 687.253906 L 624.109375 220.15625 L 405.109375 220.148438 L 405.109375 736.375 L 582.402344 687.246094 Z M 582.402344 687.253906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 249.007812 422.917969 L 255.015625 489.949219 L 405.109375 489.949219 L 405.109375 422.917969 Z M 249.007812 422.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 236.925781 287.1875 L 243.023438 354.246094 L 405.109375 354.246094 L 405.109375 287.1875 Z M 236.925781 287.1875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 405.109375 597.042969 L 404.816406 597.125 L 330.121094 576.949219 L 325.34375 523.476562 L 258.015625 523.476562 L 267.410156 628.765625 L 404.796875 666.890625 L 405.109375 666.804688 Z M 405.109375 597.042969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2c90847cdc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 263.320312 26.882812 L 344.554688 26.882812 L 344.554688 60.84375 L 297.289062 60.84375 L 297.289062 94.800781 L 344.554688 94.800781 L 344.554688 128.761719 L 263.320312 128.761719 Z M 263.320312 26.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#73d0dc300d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 360.796875 26.882812 L 442.03125 26.882812 L 442.03125 56.414062 L 394.777344 56.414062 L 394.777344 62.320312 L 442.03125 62.320312 L 442.03125 130.238281 L 360.796875 130.238281 L 360.796875 99.234375 L 408.070312 99.234375 L 408.070312 93.324219 L 360.796875 93.324219 Z M 360.796875 26.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e146d377d4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 458.285156 26.882812 L 539.515625 26.882812 L 539.515625 56.414062 L 492.242188 56.414062 L 492.242188 62.320312 L 539.515625 62.320312 L 539.515625 130.238281 L 458.285156 130.238281 L 458.285156 99.234375 L 505.539062 99.234375 L 505.539062 93.324219 L 458.285156 93.324219 Z M 458.285156 26.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 560.792969 422.917969 L 572.886719 287.1875 L 404.878906 287.1875 L 404.878906 354.246094 L 499.382812 354.246094 L 493.292969 422.917969 L 404.878906 422.917969 L 404.878906 489.949219 L 487.476562 489.949219 L 479.683594 576.910156 L 404.878906 597.105469 L 404.878906 666.847656 L 542.375 628.765625 L 543.382812 617.425781 L 559.152344 440.910156 Z M 560.792969 422.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.3fd9dffb90d623bf232fce7cf307eb7b.svg";
export { ForwardRef as ReactComponent };